import http from 'plugins/axios'

export default {
  //更新后的查询所有用户信息
  getUserList(params) {
    return http.get({
      url: `/ta/admin/channel/order/list`,
      params,
    })
  },
  exportExcel(params) {
    return http.get({
      url: `/ta/admin/channel/order/list/excel`,
      params,
      responseType:'blob',
    })
  },
  //获取交易对列表
  getSymbolList() {
    return http.get({
      url: '/ta/admin/tenant/symbol/getSymbolList',data:{type:'CONTRACT'},
    })
  },

  //获取币种列表
  getCoinList() {
    return http.get({
      url: '/ta/admin/channel/common/coinList',
    })
  },
}
